/** Baked poses and locomotion share these render-only measurements. */
export const UNIT_WALK_FRAMES = 6;
export const UNIT_WORK_FRAMES = 6;
export const UNIT_STRIDE_TILES = 0.78;

export type UnitPose = 'idle' | 'walk' | 'work';

/** Distance, rather than elapsed time, keeps boots attached to a marching pace. */
export function travelFrame(distance: number): number {
  return ((Math.floor(distance / UNIT_STRIDE_TILES * UNIT_WALK_FRAMES) % UNIT_WALK_FRAMES)
    + UNIT_WALK_FRAMES) % UNIT_WALK_FRAMES;
}

export function gait(frame: number, pose: UnitPose): { stride: number; liftLeft: number; liftRight: number; bend: number } {
  const phase = frame / UNIT_WALK_FRAMES * Math.PI * 2;
  return pose === 'walk'
    ? { stride: Math.cos(phase), liftLeft: Math.max(0, Math.sin(phase)) * 1.8,
      liftRight: Math.max(0, -Math.sin(phase)) * 1.8, bend: 0 }
    : { stride: 0, liftLeft: 0, liftRight: 0,
      bend: pose === 'work' ? [0, 0.15, 0.48, 1, 0.76, 0.27][frame % UNIT_WORK_FRAMES] : 0 };
}
